module.exports = __webpack_public_path__ + "static/media/Noah-BoldItalic.608fe554.woff";